import { Box, Text } from '@chakra-ui/react';

interface CopyrightProps {}

const Copyright: React.FC<CopyrightProps> = () => {
  return (
    <Box position="absolute" bottom={6}>
      <a color="inherit" href="https://myothis.com/" target={'_blank'} rel="noopener noreferrer">
        <Text textAlign="center" color="gray.500">
          {'Copyright © '}
          Myothis {new Date().getFullYear()}
        </Text>
      </a>
    </Box>
  );
};

export default Copyright;
